import React, { useState } from "react";
import {
  getSalaryApprovalDetailV2,
  pushPayrollApprovalToFinansist,
} from "../../../../api/timesheetApi";
import {
  FINANSIST_PUSH_DRY_RUN,
  buildUserIdToNameFromApprovalDetail,
  formatFinansistPushResultMessage,
} from "../../../../utils/finansistPayrollPush";
import "../../../Approvals/SalaryApproval/SalaryApprovalDetail.css";

const FinansistPushActions = ({ approvalId, visible }) => {
  const [isPushingToFinansist, setIsPushingToFinansist] = useState(false);
  const [showFinansistModal, setShowFinansistModal] = useState(false);
  const [showFinansistResultModal, setShowFinansistResultModal] =
    useState(false);
  const [finansistResultText, setFinansistResultText] = useState("");
  const [finansistResultVariant, setFinansistResultVariant] =
    useState("success");

  if (!visible || !approvalId) {
    return null;
  }

  const closeFinansistResultModal = () => {
    setShowFinansistResultModal(false);
    setFinansistResultText("");
  };

  const handlePushToFinansist = async () => {
    setIsPushingToFinansist(true);
    try {
      const result = await pushPayrollApprovalToFinansist({
        approval_id: approvalId,
        dry_run: FINANSIST_PUSH_DRY_RUN,
        on_missing_contragent: "skip",
        include_documents_in_response: true,
      });
      const hasPerUserFailures = (
        Array.isArray(result?.per_user) ? result.per_user : []
      ).some((u) => u && u.ok === false);
      let userIdToName = new Map();
      if (hasPerUserFailures) {
        try {
          const approvalDetail = await getSalaryApprovalDetailV2(approvalId);
          userIdToName = buildUserIdToNameFromApprovalDetail(approvalDetail);
        } catch (e) {
          console.error(e);
        }
      }
      setFinansistResultVariant("success");
      setFinansistResultText(
        formatFinansistPushResultMessage(result, userIdToName),
      );
      setShowFinansistModal(false);
      setShowFinansistResultModal(true);
    } catch (e) {
      console.error(e);
      setFinansistResultVariant("error");
      setFinansistResultText(
        e?.message || "Не удалось отправить зарплату в Finansist.",
      );
      setShowFinansistModal(false);
      setShowFinansistResultModal(true);
    } finally {
      setIsPushingToFinansist(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className="salary-detail__button salary-detail__button--submit"
        onClick={() => setShowFinansistModal(true)}
        disabled={isPushingToFinansist}
      >
        {isPushingToFinansist
          ? "Отправка в Finansist..."
          : "Отправить в Finansist"}
      </button>

      {showFinansistModal && (
        <div
          className="popup-overlay"
          onClick={() => setShowFinansistModal(false)}
        >
          <div
            className="popup popup-reject"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="popup-reject__title">Отправка в Finansist</h3>
            <p className="popup-reject__subtitle">
              {FINANSIST_PUSH_DRY_RUN
                ? "Тестовый прогон (dry_run): документы в Finansist не создаются. Параметры:"
                : "Будет выполнена фактическая отправка в Finansist. Параметры:"}
              <br />
              <code>approval_id={approvalId}</code>,{" "}
              <code>dry_run={FINANSIST_PUSH_DRY_RUN ? "true" : "false"}</code>,{" "}
              <code>on_missing_contragent=skip</code>
            </p>
            <div className="popup-buttons">
              <button
                type="button"
                className="popup-button popup-button-cancel"
                onClick={() => setShowFinansistModal(false)}
                disabled={isPushingToFinansist}
              >
                Отмена
              </button>
              <button
                type="button"
                className="popup-button popup-button-confirm popup-button-confirm--approve"
                onClick={handlePushToFinansist}
                disabled={isPushingToFinansist}
              >
                {isPushingToFinansist ? "Отправка..." : "Отправить"}
              </button>
            </div>
          </div>
        </div>
      )}

      {showFinansistResultModal && (
        <div className="popup-overlay" onClick={closeFinansistResultModal}>
          <div
            className="popup popup-finansist-result"
            onClick={(e) => e.stopPropagation()}
          >
            <h3
              className={`popup-finansist-result__title ${
                finansistResultVariant === "error"
                  ? "popup-finansist-result__title--error"
                  : ""
              }`}
            >
              {finansistResultVariant === "error"
                ? "Ошибка отправки в Finansist"
                : "Результат отправки в Finansist"}
            </h3>
            <pre className="popup-finansist-result__body">
              {finansistResultText}
            </pre>
            <div className="popup-buttons">
              <button
                type="button"
                className="popup-button popup-button-confirm popup-button-confirm--approve"
                onClick={closeFinansistResultModal}
              >
                Закрыть
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FinansistPushActions;
